module.exports = __webpack_public_path__ + "assets/img/3.260a3e7d.png";